// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  top: 0;
  width: 100%;
  height: var(--header-height)s;
  display: flex;
  border-bottom: 1px solid var(--line);
  box-shadow: 0 1px 2px #0000000a;
  background-color: #fff;
  align-items: center;
  line-height: 1;
  z-index: 1; /* Place above the contents */
  transition: transform 150ms;
}

.headerStart {
  flex: 1;
}

.headerToolbarSlot {
  display: contents;
}

.headerPath {
  margin-left: 8px; 
}

.headerPath,
.headerTitle,
.headerPathBreadcrumbs {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  gap: var(--header-gap);
  
  & a {
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

.headerPathBreadcrumbs {
  padding-block: var(--header-gap);
}

.headerPathHome {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

/* mask-image is set inline from process.env.SITE_HOME_ICON (see .env.<site>). */
.headerPathHomeIcon {
  width: 1.15em;
  height: 1.15em;
  flex-shrink: 0;
  background-color: var(--accent);
  mask-position: center;
  mask-size: contain;
  mask-repeat: no-repeat;
}

.headerSiteNameTitle {
  padding-inline-start: 5px;
  font-weight: bold;
  font-weight: 600;
}

.headerSlideIn {
  display: inline-block;
  overflow: hidden;
  flex-shrink: 0;
}

.headerSlideInAnimate {
  transition: width 200ms;
}

.headerSlideInContents {
  width: max-content;
  padding: 4px 8px;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
}

.headerFloppyDiskLockup {
  display: block;
  height: 24px;
  width: auto;
  margin: 0 5px;
}

.headerEnd {
  display: flex;
  flex-shrink: 0;
  padding: var(--header-gap);
  gap: var(--header-gap);
}

.headerStart {
  display: flex;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.headerPathFull > a {
  color: #000;
}

.headerPathFull > a:hover {
  text-decoration: none;
}

.headerPathMobile {
  display: none;
  line-height: 0;
}

.headerPathBack {
  display: inline-block;
  width: 25px;
  height: 19px;
  background-color: #eee;
  border: 1px solid #888;
  border-radius: 4px;
  margin: 0;
  line-height: 0;
  position: relative;
  margin-left: 9px;
}

.headerPathBack::after {
  content: "";
  width: 7px;
  height: 7px;
  transform: rotate(225deg);
  border-top: 2px solid #000;
  border-right: 2px solid #000;
  top: 5px;
  position: absolute;
  left: 9px;
}

.headerFileStoreSelection {
  ---text-color: var(--accent);
  border: 0;
  background: transparent;
  font: inherit;
  cursor: pointer;
  color: var(--accent);
  text-decoration: none;
  padding: 0px 11px 0px 4px;
  border-radius: 3px;
  height: 31px;
  text-wrap: nowrap;
}

/* The down arrow */
.headerFileStoreSelection::after {
content: "";
  border: solid var(---text-color);
  border-width: 0 1.5px 1.5px 0;
  display: inline-block;
  padding: 2.5px;
  transform: rotate(45deg);
  position: relative;
  right: -5px;
  top: -3px;
}

.headerFileStoreSelection:hover {
  outline: 2px solid var(--accent-tint);
  background: var(--accent-tint);
}

.headerFileStoreSelection:active {
  outline: 2px solid var(--accent);
}

.headerFileStoreSelection:focus {
  outline: 2px solid #7c3aedaa;
}

.button.headerSaveFile {
  color: #fff;
  background-color: var(--accent);
  border: 1px solid var(--accent-strong);
}

@media (max-width: 500px) {
  .headerPathFull {
    display: none;
  }

  .headerPathMobile {
    display: block;
  }
}

@media print {
  .header {
     display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,oCAAoC;EACpC,+BAA+B;EAC/B,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,UAAU,EAAE,6BAA6B;EACzC,2BAA2B;AAC7B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;;EAEtB;IACE,qBAAqB;;IAErB;MACE,0BAA0B;IAC5B;EACF;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,QAAQ;EACR,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;AACA,WAAW;EACT,gCAAgC;EAChC,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;KACG,aAAa;EAChB;AACF","sourcesContent":[".header {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  height: var(--header-height)s;\n  display: flex;\n  border-bottom: 1px solid var(--line);\n  box-shadow: 0 1px 2px #0000000a;\n  background-color: #fff;\n  align-items: center;\n  line-height: 1;\n  z-index: 1; /* Place above the contents */\n  transition: transform 150ms;\n}\n\n.headerStart {\n  flex: 1;\n}\n\n.headerToolbarSlot {\n  display: contents;\n}\n\n.headerPath {\n  margin-left: 8px; \n}\n\n.headerPath,\n.headerTitle,\n.headerPathBreadcrumbs {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: flex;\n  gap: var(--header-gap);\n  \n  & a {\n    text-decoration: none;\n    \n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.headerPathBreadcrumbs {\n  padding-block: var(--header-gap);\n}\n\n.headerPathHome {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n/* mask-image is set inline from process.env.SITE_HOME_ICON (see .env.<site>). */\n.headerPathHomeIcon {\n  width: 1.15em;\n  height: 1.15em;\n  flex-shrink: 0;\n  background-color: var(--accent);\n  mask-position: center;\n  mask-size: contain;\n  mask-repeat: no-repeat;\n}\n\n.headerSiteNameTitle {\n  padding-inline-start: 5px;\n  font-weight: bold;\n  font-weight: 600;\n}\n\n.headerSlideIn {\n  display: inline-block;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.headerSlideInAnimate {\n  transition: width 200ms;\n}\n\n.headerSlideInContents {\n  width: max-content;\n  padding: 4px 8px;\n  display: inline-flex;\n  align-items: center;\n  overflow: hidden;\n}\n\n.headerFloppyDiskLockup {\n  display: block;\n  height: 24px;\n  width: auto;\n  margin: 0 5px;\n}\n\n.headerEnd {\n  display: flex;\n  flex-shrink: 0;\n  padding: var(--header-gap);\n  gap: var(--header-gap);\n}\n\n.headerStart {\n  display: flex;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.headerPathFull > a {\n  color: #000;\n}\n\n.headerPathFull > a:hover {\n  text-decoration: none;\n}\n\n.headerPathMobile {\n  display: none;\n  line-height: 0;\n}\n\n.headerPathBack {\n  display: inline-block;\n  width: 25px;\n  height: 19px;\n  background-color: #eee;\n  border: 1px solid #888;\n  border-radius: 4px;\n  margin: 0;\n  line-height: 0;\n  position: relative;\n  margin-left: 9px;\n}\n\n.headerPathBack::after {\n  content: \"\";\n  width: 7px;\n  height: 7px;\n  transform: rotate(225deg);\n  border-top: 2px solid #000;\n  border-right: 2px solid #000;\n  top: 5px;\n  position: absolute;\n  left: 9px;\n}\n\n.headerFileStoreSelection {\n  ---text-color: var(--accent);\n  border: 0;\n  background: transparent;\n  font: inherit;\n  cursor: pointer;\n  color: var(--accent);\n  text-decoration: none;\n  padding: 0px 11px 0px 4px;\n  border-radius: 3px;\n  height: 31px;\n  text-wrap: nowrap;\n}\n\n/* The down arrow */\n.headerFileStoreSelection::after {\ncontent: \"\";\n  border: solid var(---text-color);\n  border-width: 0 1.5px 1.5px 0;\n  display: inline-block;\n  padding: 2.5px;\n  transform: rotate(45deg);\n  position: relative;\n  right: -5px;\n  top: -3px;\n}\n\n.headerFileStoreSelection:hover {\n  outline: 2px solid var(--accent-tint);\n  background: var(--accent-tint);\n}\n\n.headerFileStoreSelection:active {\n  outline: 2px solid var(--accent);\n}\n\n.headerFileStoreSelection:focus {\n  outline: 2px solid #7c3aedaa;\n}\n\n.button.headerSaveFile {\n  color: #fff;\n  background-color: var(--accent);\n  border: 1px solid var(--accent-strong);\n}\n\n@media (max-width: 500px) {\n  .headerPathFull {\n    display: none;\n  }\n\n  .headerPathMobile {\n    display: block;\n  }\n}\n\n@media print {\n  .header {\n     display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
